import React from "react";

import TimeInst from "components/notification/shared/TimeInst";

import calendarIcon from "../assets/calendar.svg";

function NotificationTime({ notification }) {
  return (
    <strong>
      <img src={calendarIcon} alt="" />
      <TimeInst date={new Date(notification?.createdAt)} />
    </strong>
  );
}

export default NotificationTime;
